import { FramerNextPages } from '@graphcommerce/framer-next-pages'
import { GraphQLProvider } from '@graphcommerce/graphql'
import { GlobalHead } from '@graphcommerce/magento-store'
import {
  CssAndFramerMotionProvider,
  DarkLightModeThemeProvider,
  PageLoadIndicator,
} from '@graphcommerce/next-ui'
import { CssBaseline } from '@mui/material'
import { AppProps } from 'next/app'
import { lightTheme, darkTheme } from '../components/theme'
import { I18nProvider } from '../lib/i18n/I18nProvider'
import { i18n } from '@lingui/core'
import { es, en } from 'make-plural/plurals'
import { useAutoLogoutOnExpiration } from '../hooks/useAutoLogoutOnExpiration'
import { useExtendSessionOnActivity } from '../hooks/useExtendSessionOnActivity'
i18n.loadLocaleData({ es: { plurals: es }, en: { plurals: en } })

function AppWithSessionManagement() {
  useAutoLogoutOnExpiration()
  useExtendSessionOnActivity()
  return null
}

export default function ThemedApp(props: AppProps) {
  const { router } = props
  const { locale = 'en' } = router

  return (
    <CssAndFramerMotionProvider>
      <I18nProvider key={locale} locale={locale}>
        <GraphQLProvider {...props}>
          <DarkLightModeThemeProvider light={lightTheme} dark={darkTheme}>
            <GlobalHead />
            <CssBaseline />
            <PageLoadIndicator />
            <AppWithSessionManagement />
            <FramerNextPages {...props} />
          </DarkLightModeThemeProvider>
        </GraphQLProvider>
      </I18nProvider>
    </CssAndFramerMotionProvider>
  )
}
